import React from 'react';
import GRN from './GRN';
import DeliveryNote from './DeliveryNote';
import RequestApproval from './RequestApproval';

function Approvals() {
  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex items-center justify-between pb-3 border-b border-gray-100 mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse"></div>
          <h3 className="text-sm font-semibold text-gray-800">Stores Approvals Overview</h3>
        </div>
        <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
          Live Inventory Status
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <GRN />
        <DeliveryNote />
        <RequestApproval />
      </div>
    </div>
  );
}

export default Approvals;